import type { FilterRuleModel } from '@/shared/generated'

import { useCallback } from 'react'
import { filter, keys, map, pipe } from 'lodash/fp'

import { Operators } from '@/shared/components/query-builder'

import { useDatasheetStore } from '../lib/datasheet/store'

const parseRowIds = pipe([
	map((id: string): string => id.split('__')[2]),
	filter(Boolean),
])

export const useSelectedItemsFilters = () => {
	const store = useDatasheetStore()

	return useCallback(
		(pageFilters: FilterRuleModel[]): FilterRuleModel[] => {
			const { isAllProductsSelected, rowSelection } = store.getState()
			const rowIds = keys(rowSelection)
			if (isAllProductsSelected) {
				return pageFilters.length
					? pageFilters
					: [
							{
								name: 'sku',
								operation: Operators.IS_NOT_EMPTY,
								value: 1,
							},
						]
			} else if (rowIds.length) {
				return [
					{
						name: 'sku',
						operation: Operators.IN,
						value: parseRowIds(rowIds),
					},
				]
			} else {
				return []
			}
		},
		[store]
	)
}
